/**
 * After the first create-response POST, merge server identity fields onto the
 * in-memory draft so Sparkle Fill sees the persisted id without discarding
 * answers the member already typed.
 */
export const mergeSurveyResponseAfterCreate = (current, created) => {
  if (!current || !created?.id) {
    return current;
  }

  return {
    ...current,
    id: created.id,
    subject: current.subject?.reference ? current.subject : created.subject,
    questionnaire: current.questionnaire?.reference
      ? current.questionnaire
      : created.questionnaire,
    meta: created.meta ?? current.meta,
  };
};
